import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface RightPanelProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  width?: 'md' | 'lg' | 'xl';
}
export function RightPanel({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  width = 'lg'
}: RightPanelProps) {
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) onClose();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  const widthClasses = {
    md: 'w-[400px]',
    lg: 'w-[480px]',
    xl: 'w-[600px]'
  };
  return <>
      {/* Backdrop */}
      <div className={`fixed inset-0 bg-black/70 backdrop-blur-sm z-40 transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={onClose} data-id="element-951" />

      {/* Panel */}
      <div className={`fixed right-0 top-0 h-full ${widthClasses[width]} bg-[#111111]/98 backdrop-blur-xl border-l border-white/[0.08] z-50 transform transition-transform duration-300 ease-out ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-952">
        <div className="flex flex-col h-full" data-id="element-953">
          {/* Header */}
          <div className="flex-shrink-0 px-6 py-5 border-b border-white/[0.08]" data-id="element-954">
            <div className="flex items-start justify-between" data-id="element-955">
              <div className="flex-1 min-w-0 mr-4" data-id="element-956">
                <h2 className="text-[16px] font-semibold text-white tracking-tight truncate" data-id="element-957">
                  {title}
                </h2>
                {subtitle && <p className="text-[12px] text-white/35 mt-0.5" data-id="element-958">{subtitle}</p>}
              </div>
              <button onClick={onClose} className="p-2 text-white/25 hover:text-white/50 hover:bg-white/[0.04] rounded-lg transition-all duration-200" data-id="element-959">
                <X className="w-4 h-4" data-id="element-960" />
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto custom-scrollbar" data-id="element-961">
            {children}
          </div>
        </div>
      </div>
    </>;
}